/**
 * @description Usage <input on-enter="doSomething()" on-enter-if="ifTruthy()"></input>
 */
;(function () {
  angular.module('contrast.form').directive('onEnter', function () {
    return {
      restrict: 'A',
      scope: {
        onEnterIf: '=',
        onEnter: '='
      },
      link: function (scope, element) {
        element.on('keyup', function (event) {
          if (scope.onEnterIf) {
            var key =
              typeof event.which === 'undefined' ? event.keyCode : event.which
            if (key === 13) {
              scope.onEnter()
              event.preventDefault()
            }
          }
        })
      }
    }
  })
})()
